import { parseVersionHistoryText } from '@/features/factsheet/lib/versionHistory';
import type { FactsheetDetails } from '@/features/factsheet/types';

import UnregisteredBanner from '../../UnregisteredBanner';
import TextLinesDisplay from '../TextLinesDisplay';

interface QualitySpecTabProps {
  factsheet: FactsheetDetails;
  isAuthenticated: boolean;
}

const QualitySpecTab = ({ factsheet, isAuthenticated }: QualitySpecTabProps) => {
  if (!isAuthenticated) {
    return (
      <div className='pt-10'>
        <UnregisteredBanner />
      </div>
    );
  }

  const qualitySpecLines = parseVersionHistoryText(factsheet, 'qualitySpecification');

  return (
    <div>
      <TextLinesDisplay lines={qualitySpecLines} />
    </div>
  );
};

export default QualitySpecTab;
